import React, {Component} from 'react';
import {Button} from "reactstrap";

class ArchiveDropdownButton extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isMobile : window.innerWidth > 991 ? false : true
		};
	}

	render() {
		let {isMobile} = this.state;
		return (
			<div style={!isMobile ? {float:'left'} : {padding:'0px 15px 0px 0px '}} >
				<Button className={isMobile ? "MenuBtn2 listt" : "stickButton dropdown"}
						style={!isMobile ? (this.props.style ? this.props.style : { minWidth:'150px'}) : {margin:'0 30px 0 0'}}
						type="button"
						id="dropdownMenuButton"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false">
					<label className='dropdown-label' style={{fontWeight: isMobile ? 'bold' : '',margin: isMobile ? '0' : ''}}>
						{this.props.isArchive === 2 ? "Tümü" : this.props.isArchive === 1 ? "Arşivlenenler" : "Arşivlenmeyenler"}
					</label>
				</Button>
				<div className="dropdown-menu" aria-labelledby="dropdownMenuButton" >
					<a className="dropdown-item"
					   onClick={(e) => this.props.onChangeArchive(2)}>Tümü</a>
					<a className="dropdown-item"
					   onClick={(e) => this.props.onChangeArchive(1)}>Arşivlenenler</a>
					<a className="dropdown-item"
					   onClick={(e) => this.props.onChangeArchive(0)}>Arşivlenmeyenler</a>
				</div>
			</div>
		)
	}
}

export default ArchiveDropdownButton;